// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__4l6sE","title":"FrontImage_title__1aSw7"};